import { useEffect } from 'react';
import { toast } from 'sonner';

// Stops a single swipe-back / back press from throwing mobile users out of the app.
// Adds one buffer history entry; reaching the first entry re-arms it and shows a
// hint, so leaving takes a deliberate second swipe.
export const BackExitGuard = () => {
  useEffect(() => {
    if (!('ontouchstart' in window)) return;
    let lastWarn = 0;
    window.history.pushState({ ...window.history.state, mintedBuffer: true }, '', window.location.href);
    const onPop = () => {
      const idx = window.history.state?.idx;
      if (idx === 0 || idx === undefined || window.history.state === null) {
        const now = Date.now();
        if (now - lastWarn > 2500) {
          lastWarn = now;
          window.history.pushState({ ...window.history.state, mintedBuffer: true }, '', window.location.href);
          toast('Swipe back again to leave Minted', { duration: 2000 });
        }
      }
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  return null;
};

export default BackExitGuard;
